<template>
  <div class="signInDetail">
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div class="mobileHeader">
      <p>
        <span>出库单号：{{ list.outboundNo }}</span>
        <span>参考单号：{{ list.orgOutboundNo }}</span>
      </p>
      <p>
        <span>预发箱数：{{ list.boxCount }}</span>
        <span>入库箱数：{{ list.inStockCount }}</span>
      </p>
      <p>
        <span>预计发货：{{ list.deliveryDate }}</span>
        <span>已拣箱数：{{ list.pickCount }}</span>
      </p>
    </div>
    <div>
      <ul class="bale-container">
        <li>
          <div>进仓单号</div>
          <div>库位</div>
          <div>箱数(卡板)</div>
        </li>
        <template v-if="list.deliveryOrders.length">
          <li v-for="(item, index) in list.deliveryOrders" :key="index">
            <div>{{ item.deliveryOrdeNo }}</div>
            <div>{{ item.storages }}</div>
            <div>
              {{ item.boxCount
              }}{{ item.palletQty>0 ? "(" + item.palletQty + ")" : "" }}
            </div>
          </li>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
      </ul>
    </div>
    <div class="sign-item">

      <div class="signInDetail-btnBox">
        <div class="scanBox">
          <van-field
            size="small"
            v-model="list.scanCode"
            placeholder="扫描下架,支持进仓单号或托唛"
            right-icon="scan"
            @click-right-icon="scanDoc"
            @keyup.13="pickOut()"
            @focus="codeFocus"
            ref="scanCode"
          />

          <div class="toSearch-box">
            <button class="sign-toSearch" @click="pickOut()">下架</button>
          </div>
        </div>

        <div class="scanBox">
          <van-field
            size="small"
            v-model="list.locationCode"
            placeholder="备货区库位"
            right-icon="scan"
            @click-right-icon="scan"
            @focus="storageFocus"
            @input="storageChange"
            @blur="codeFocus()"
            ref="storage"
          />
        </div>
      </div>

      <div>
        <p class="p-title">备柜照片(按SKU种类上传)</p>
        <div class="photo">
          <div class="sign-photo-cpntent">
            <div class="sign-photo-box">
              <ul>
                <li
                  class="sign-photo-item"
                  v-for="(item, index) in skuImg"
                  :key="index"
                >
                  <span class="delete-icon" @click="deleteImg(index)">x</span>
                  <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                  <img
                    :src="item"
                    class="sign-photo-item-img"
                    alt=""
                    @click="previewImage(item)"
                  />
                </li>

                <li class="sign-photo-btn">
                  <div class="photo">
                    <input
                      class="img hidden receive"
                      @change="changeImg()"
                      type="file"
                      name="cover"
                      ref="inputer"
                      accept="image/*"
                      multiple
                    />
                    <p @click="chooseImage">
                      <i class="el-icon-camera"></i>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="signInDetail-receipt-main">
        <button class="signInDetail-receipt" @click="submit">确认拣货</button>
      </div>
    </div>

    <van-popup v-model="showPicker" round position="bottom" :overlay="false">
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :loading="loading"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
  </div>
</template>

<script>
// 在导入语句中添加Empty组件
import { Field, Toast, Popup, Picker, ImagePreview, Empty } from "vant";
import util from "util/date";
import {
  getOutbound,
  submitPick,
  pickOut,
} from "@/api/mobile/jy-outboundPick_api";
import { getWarehouseLocation } from "@/api/mobile/stock_api";
import { mixins } from "../mobileMixins";
import { BaseApiUrl } from "@/api/axios_config";
import axios from "axios";
export default {
  data() {
    return {
      list: {deliveryOrders: []},
      itemArr: ["本次签收数量"],
      showPicker: false,
      columns: [],
      containTailDisabled: false,
      loading: false,
      viewportHeight: 0,
      focusType: "",
      skuImg: [],
      saveImgUrlArr: [],
      imgFiles: [],
    };
  },

  components: {
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [ImagePreview.name]: ImagePreview,
    // 添加Empty组件注册
    [Empty.name]: Empty
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  methods: {
    
    changeImg() {
      const img = document.getElementsByClassName("img")[0];

      if (!img.files.length) return;

      this.handleFiles(img.files);

      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.submitImg();
    },
    chooseImage() {
      document.getElementsByClassName("receive")[0].click();
    },
    handleFiles(files) {
      const that = this;
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
          that.$set(that.skuImg, that.skuImg.length, e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },
     deleteImg(i) {
      this.skuImg.splice(i, 1);
      // this.imgFiles.splice(i,1)
      this.saveImgUrlArr.splice(i, 1);
    },
    submitImg() {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
         this.saveImgUrlArr.push(...res.data.response);
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
        // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },
    pickOut() {
      const that = this;
      console.info(this.list.scanCode);
      if (this.list.scanCode == undefined) {
        this.showsound(false);
        Toast.fail("请输入或扫描单号");
        return;
      }
      const { tfOutboundID } = this.list;
      const data = {
        TFOutboundID: tfOutboundID,
        ScanCode: this.list.scanCode,
      };
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      pickOut(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          Toast.success("操作成功");
          setTimeout(() => {
            that.getOutbound();
          }, 500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }

        // 使用 $nextTick 确保 DOM 更新后再执行选择
        this.$nextTick(() => {
          // 直接访问 input 元素并选择文本
          const input = this.$refs.scanCode.$el.querySelector("input");
          if (input) {
            input.select(); // 选择文本
          }
        });
      });
    },
    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.list, "locationCode", a.resultStr);
        },
      });
    },
    onConfirm(val) {
      this.$set(this.list, "locationCode", val);
      this.showPicker = false;
    },
    init() {
      const that = this;
      window.addEventListener(
        "resize",
        function () {
          if (that.viewportHeight - this.innerHeight > 50) {
            // 键盘弹起
            if (that.focusType === "locationCode") {
              that.showPicker = false;
            }
            const activeElement = document.activeElement;
            if (
              activeElement.tagName === "INPUT" ||
              activeElement.tagName === "TEXTAREA"
            ) {
              that.$nextTick(function () {
                that.$refs.storage.focus
                  ? (that.$refs.storage.scrollTop = 100)
                  : (that.$refs.boxCount.scrollTop = 100);
              });
            }
          } else {
            // 键盘收起
            if (that.focusType === "locationCode") {
              that.showPicker = true;
            }
          }
        },
        true
      );
      this.getOutbound();
    },
    // 库位获取焦点
    storageFocus() {
      this.showPicker = true;
      this.focusType = "locationCode";
      this.storageChange();
    },
    //单据号获取焦点
    codeFocus() {
      this.showPicker = false;
    },

    storageChange() {
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;

      const { locationCode } = this.columns;
      const { warehouseId } = _warehouse;
      if (this.columns.length > 0) return;

      const data = { locationCode: locationCode, warehouseId, areaType: 20 }; //地堆区
      this.loading = true;

      getWarehouseLocation(data).then((res) => {
        this.loading = false;
        if (res.status === 200) {
          const { response } = res;

          try {
            let arr = [];
            response.forEach((item) => {
              arr.push(item.locationCode);
            });
            this.columns = arr;
          } catch {}
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    scan() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.list, "locationCode", a.resultStr);
        },
      });
    },
    scanDoc() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.list, "scanCode", a.resultStr);
        },
      });
    },
    getOutbound() {
      const { outboundNo } = this.$route.query;
      const data = {
        outboundNo,
      };

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getOutbound(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          const { response } = res;

          try {
            response.deliveryDate = util.formatDate.format(
              new Date(response.deliveryDate),
              "yyyy-MM-dd"
            );
          } catch {}
          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      console.info(this.list);
      if (this.list.deliveryOrders.length > 0) {
        this.showsound(false);
        return Toast.fail("请扫描进仓单号或托唛下架");
      }
      if (!this.list.locationCode) {
        this.showsound(false);
        return Toast.fail("请输入备货区库位");
      }
      const { tfOutboundID, locationCode } = this.list;
      const data = {
        tfOutboundID,
        locationCode,
        remark: "",
        file: this.saveImgUrlArr,
      };

      Toast.loading({
        message: "拣货中...",
        forbidClick: true,
      });

      submitPick(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          this.showsound(true);
          Toast.success("拣货成功");
          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.signInDetail .mobileHeader {
  padding: 0 10px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;

  > p {
    display: flex;

    > span {
      flex: 1;
    }
  }
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
}
.sign-item {
  background-color: #fbf9fe;
  .signInDetail-content {
    font-size: 15px;
  }

  .signInDetail-btnBox {
    li {
      line-height: 40px;
      white-space: nowrap;
      align-items: baseline;
      padding: 5px 10px 2px 1px;
      width: 95%;
      font-size: 14px;
    }

    .volume {
      min-width: 10%;
      max-width: 17%;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      border: 1px solid #ccc;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }

    .van-cell {
      margin-left: 10px;
      border: 1px solid #adadad;
      flex: 1;
    }
  }
}
.scanBox{
  display:flex;
  padding:10px;
}
.toSearch-box {
  margin-left: 3%;
  min-height: inherit;
}
.sign-toSearch {
  height: 100%;
  width: 100%;
  border-radius: 5px;
    background-color: #169bd5;
    color: #fff;
}
.signInDetail-receipt-main {
  padding: 0px 10px 15px;
}
.signInDetail-receipt {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  margin-top: 20px;
  font-size: 18px;
  border: 0;
}

.btn {
  width: 35%;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 14px;
  border: 0;
  height: 25px;
  line-height: 25px;
}

.sign-photo-box {
  margin: 5px 10px 10px;
  box-sizing: border-box;
  padding: 10px;

  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }

      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }

    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;

      .photo {
        height: 100px;
        position: relative;
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;

        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;

          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}

.sign-photo-save {
  padding: 0 10px;
}

::v-deep .van-icon-photo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fl {
  flex: 1 1 0%;
  max-width: 100% !important;
}

.hidden {
  display: none;
}
.bale-container li {
  display: flex;
  line-height: 40px;
  font-size: 14px;
  & > div {
    flex: 0.5;
    text-align: center;
  }
  & > div:first-child {
    flex: 1;
  }
}
@media screen and (max-width: 360px) {
  .signInDetail-btnBox {
    li {
      font-size: 14px;
    }
  }
}
</style>
